// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaticInfoBlock-container-c6yCD {
    margin: 0 auto;
    max-width: 1274px;
    padding: 0 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/StaticInfoBlock/StaticInfoBlock.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".container {\n    margin: 0 auto;\n    max-width: 1274px;\n    padding: 0 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StaticInfoBlock-container-c6yCD`
};
module.exports = ___CSS_LOADER_EXPORT___;
